// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3PC0n","head":"ProcedureTableInfo_head__12qJs"};